

import React from "react";

export const CableCar3 = ({ className ,state="defualt"}) => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_69_814)" opacity="0.5">
        <path
          d="M6.66732 1.99998H6.67398M9.33398 1.33331H9.34065M1.33398 5.99998L14.6673 2.66665M8.00065 7.99998V4.33331M6.00065 7.99998V11.3333M10.0007 7.99998V11.3333M2.66732 11.3333H13.334M4.66732 7.99998H11.334C12.4386 7.99998 13.334 8.89541 13.334 9.99998V12.6666C13.334 13.7712 12.4386 14.6666 11.334 14.6666H4.66732C3.56275 14.6666 2.66732 13.7712 2.66732 12.6666V9.99998C2.66732 8.89541 3.56275 7.99998 4.66732 7.99998Z"
          stroke={state=="active"?"white":"black"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.33333"
        />
      </g>

      <defs>
        <clipPath id="clip0_69_814">
          <rect fill="white" height="16" width="16" />
        </clipPath>
      </defs>
    </svg>
  );
};
